import React, {useState} from "react";
import { Input} from "antd";
import styled from "styled-components";

const StyledInputWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex-direction: row;
    margin-bottom: 25px;
    
    input {
        width: 80%;
    }
`;

const StyledWrapper = styled.div`
    color: white;

    button {
        font-size: 16px;
        border-radius: 5px;
        padding: 10px;
        color: white;
        background: red;
        box-shadow: none;
        border: none;
    }

    button:hover {
        cursor: pointer;
        background: #e72e2e;
    }
`;

const PromptInput = ({onClick}) => {
    const [prompt, setPrompt] = useState("");

    return (
        <StyledWrapper>
            <h3>
                Please tell what your Santa should do:
            </h3>
            <StyledInputWrapper>
                <Input type="text" id="prompt" name="prompt" onChange={(event) => setPrompt(event?.target?.value || '')} />
                <button type='button' onClick={() => onClick(prompt)}>Send</button>
            </StyledInputWrapper>
        </StyledWrapper>
    );
};

export default PromptInput;
